var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBergRegions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 294,
    viewBox: "0 0 424 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7246 292.394V183.781H70.2041C91.1657 183.781 101.492 192.171 101.492 209.103C101.492 221.46 94.7107 230.307 80.9932 235.647C95.4814 238.392 102.88 246.63 102.88 260.359C102.88 281.868 91.474 292.546 68.5086 292.546H18.7246V292.394ZM67.738 275.004C76.6775 275.004 81.3014 270.427 81.3014 261.274C81.3014 249.986 74.5197 244.342 61.1104 244.342H54.9452V231.375C71.8995 228.629 80.2225 221.612 80.2225 210.324C80.2225 204.222 76.3693 201.171 68.8169 201.171H39.0698V274.851H67.738V275.004Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M195.356 183.781V201.171H140.332V228.477H192.736V246.477H140.178V275.004H196.435V292.546H120.141V183.781H195.356Z",
    fill: "#323232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M215.241 292.241V183.781H265.179C287.682 183.781 298.78 193.544 298.78 212.917C298.78 226.036 289.994 236.867 272.578 245.562L307.411 292.546H281.825L248.379 245.104V235.952C267.8 232.596 277.51 225.121 277.51 213.527C277.51 205.595 272.886 201.476 263.792 201.476H236.049V292.394H215.241V292.241Z",
    fill: "#323232"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M404.668 287.36C395.882 291.174 384.785 293.157 371.376 293.157C332.535 293.157 313.269 274.241 313.269 236.562C313.269 200.866 332.997 183.019 372.454 183.019C384.477 183.019 395.266 184.849 404.668 188.358V206.663C395.266 202.544 384.939 200.561 373.996 200.561C347.64 200.561 334.384 212.613 334.384 236.715C334.384 262.8 346.869 275.919 371.684 275.919C375.383 275.919 379.544 275.309 384.323 274.089V242.512H404.668V287.36Z",
    fill: "#323232"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9517 148.389L199.366 49.9966L149.427 0.724121L0.229492 148.389H99.9517Z",
    fill: "url(#paint0_linear_205_1024)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M323.355 148.389L223.941 49.9966L273.88 0.724121L423.077 148.389H323.355Z",
    fill: "url(#paint1_linear_205_1024)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M224.642 148.389L323.902 50.1496L274.118 0.724609L124.92 148.389H224.642Z",
    fill: "url(#paint2_linear_205_1024)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M323.939 50.1356L274.133 99.4302L290.154 115.286L339.96 65.9919L323.939 50.1356Z",
    fill: "#BC235E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_205_1024",
    x1: 67.4129,
    y1: 130.64,
    x2: 154.837,
    y2: 43.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5AB256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B80C1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_205_1024",
    x1: 257.27,
    y1: 32.7373,
    x2: 365.293,
    y2: 143.491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C72884"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E73166"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_205_1024",
    x1: 177.562,
    y1: 142.881,
    x2: 294.485,
    y2: 29.2681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3D545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6153"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBergRegions);
export default __webpack_public_path__ + "static/media/berg-regions.90c529b3ee30e361a51d872de5fa3d66.svg";
export { ForwardRef as ReactComponent };